/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-cycle */
import clsx from 'clsx';
import ModalWrapper from '../../ModalWrapper';
import RichTextComponentGraphQL from '../../RichTextComponentGraphQL';
import { TMessagingBlade } from '../../../models/Message/@types';
import Typo from '../../Typo';
import VideoPlayer from '../../VideoPlayer';
import styles from './mediaCardForVideo.module.sass';
import { useIsMobileViewport } from '../../../hooks/useIsMobileViewport';

export interface MediaCardTutorialProp extends TMessagingBlade {
  open: boolean;
  onClose?: () => void;
  hasCloseButton?: boolean;
  isTutorial?: boolean;
}

const MediaCardForVideo = (props: MediaCardTutorialProp) => {
  const { videoUrl, open, onClose, description, subHeading, isTutorial = false } = props;
  const { isMobile } = useIsMobileViewport();
  return (
    <ModalWrapper
      isActive={open}
      onClose={onClose}
      hasCloseButton={isTutorial}
      // hasVideo={isTutorial}
    >
      <div className={clsx({ [styles.root]: isTutorial })}>
        {isTutorial && subHeading && (
          <Typo classes="mb-5" h2>
            {subHeading}
          </Typo>
        )}
        {description && (
          <Typo normal>
            <RichTextComponentGraphQL
              json={description.json}
              links={description?.links}
              classes="rich-text-container"
            />
          </Typo>
        )}
        {videoUrl && (
          <div className={styles.videoContainer}>
            <VideoPlayer
              videoUrl={videoUrl}
              aspectRatio={isMobile ? '1/1' : '3/2'}
              isActive={open}
            />
          </div>
        )}
      </div>
    </ModalWrapper>
  );
};

export default MediaCardForVideo;
